import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Tooltip } from '@material-ui/core';
import BorderClearIcon from '@material-ui/icons/BorderClear';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import InfoCard from './InfoCard';

function BuildableAreaInfoCard ({ isLoading, buildableArea }) {
    return (<InfoCard skeleton={isLoading}>
        <Typography>
            Buildable area
            <Tooltip arrow title={'Buildable area is the percentage area of the title not covered by constraints'} placement={'right'}>
                <InfoOutlinedIcon />
            </Tooltip>
        </Typography>
        <Typography>
            <BorderClearIcon />
            {`${buildableArea.toFixed(0)}%`}
        </Typography>
    </InfoCard>);
}

BuildableAreaInfoCard.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    buildableArea: PropTypes.number.isRequired
};

export default BuildableAreaInfoCard;